import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import { theme } from '_constants/theme';

import StatementListItem from './StatementsListItem';

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spaces.regular}px;
`;

const StatementsList = ({ items, onDownload, onUpload, onDelete }) => (
  <StyledContainer>
    {items?.map(({ id, ...restProps }) => (
      <StatementListItem
        key={id}
        id={id}
        {...restProps}
        onDownload={onDownload}
        onUpload={onUpload}
        onDelete={onDelete}
      />
    ))}
  </StyledContainer>
);

StatementsList.propTypes = {
  items: PropTypes.array,
  onDownload: PropTypes.func,
  onUpload: PropTypes.func,
  onDelete: PropTypes.func,
};

export default StatementsList;
